import get from "lodash/get";
import PropTypes from "prop-types";
import React from "react";
import { getStoryElementByType, getStoryElementsBySubType, getStoryElementsByType } from "../../../utils";
import "./agenda-section.m.css";

const AgendaItem = ({ time, title }) => (
  <div styleName="agenda-item">
    <div styleName="agenda-content">
      <div styleName="agenda-title">{title}</div>
      <div styleName="agenda-time">{time}</div>
    </div>
  </div>
);

AgendaItem.propTypes = {
  time: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export const AgendaSection = ({ card }) => {
  const title = get(getStoryElementByType(card, "title"), "text", "");
  const descriptionCard = get(getStoryElementsByType(card, "text"), "0", "");
  let description = "";
  if (descriptionCard.subtype == null) {
    description = descriptionCard.text;
  }
  const agendaItems = getStoryElementsBySubType(card, "text", "bigfact");
  const formattedAgendaItems = agendaItems.map((item) => ({
    time: get(item, ["metadata", "attribution"], ""),
    title: get(item, ["metadata", "content"], ""),
  }));
  const id = get(card, ["metadata", "attributes", "menuname", "0"], "");
  return (
    <section styleName="container" id={`${id.toLowerCase()}`}>
      <h2 styleName="title" dangerouslySetInnerHTML={{ __html: title }} />
      <div styleName="divider" />
      <div styleName="description" dangerouslySetInnerHTML={{ __html: description }} />
      <div styleName="agenda-list">
        {formattedAgendaItems.map((item, index) => (
          <AgendaItem key={index} {...item} />
        ))}
      </div>
    </section>
  );
};
